import React from 'react';
import scaleSize from '../../utils/scale-size';

const Icon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(86)}
    height={scaleSize(86)}
    viewBox="0 0 86 86"
    className={className}
  >
    <defs>
      <circle id="circle" cx="32" cy="32" r="32" />
      <filter
        id="a"
        width="151.6%"
        height="151.6%"
        x="-25.8%"
        y="-25.8%"
        filterUnits="objectBoundingBox"
      >
        <feMorphology in="SourceAlpha" operator="dilate" radius=".5" result="shadowSpreadOuter1" />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="5" />
        <feComposite
          in="shadowBlurOuter1"
          in2="SourceAlpha"
          operator="out"
          result="shadowBlurOuter1"
        />
        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(11 11)">
        <use fill="#000" filter="url(#a)" xlinkHref="#circle" />
        <use className="fill-change" fill="#F4F4F4" fillOpacity=".5" xlinkHref="#circle" />
      </g>
      <path
        fill="#FFF"
        d="M38.043 32.08l15.08 9.213a2 2 0 0 1 0 3.414l-15.08 9.214A2 2 0 0 1 35 52.214V33.786a2 2 0 0 1 3.043-1.707z"
      />
    </g>
  </svg>
);

export default Icon;
